import { Checkbox, Space, Stack } from "@mantine/core";
import React, { FC } from "react";
import { FormSubmissionS } from "../../Service/FormSubmissionS";
import type { Language } from "../../types/BookitupDocument";
import { useLingui } from "@lingui/react";
import { getDocumentTranslator } from "../Document/documentLanguage";

type AgreementDTO = {
  id: string;
  content: string;
  required: boolean;
};

interface Props {
  agreements: AgreementDTO[];
  patchSubmissionValue: (key: string, val: boolean) => void;
  values: Record<string, boolean>;
  submitted: boolean;
  showErrors: boolean;
  language?: Language;
}

const Agreements: FC<Props> = ({
  agreements,
  patchSubmissionValue,
  values,
  submitted,
  showErrors,
  language,
}) => {
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, language);
  const mapAgreementUI = (agreement: AgreementDTO) => {
    const { id, content, required } = agreement;
    const checked = FormSubmissionS.isValuePresent(id, values);
    return (
      <Checkbox
        disabled={submitted}
        onChange={(e) => patchSubmissionValue(id, e.currentTarget.checked)}
        checked={checked}
        radius="xs"
        required={required}
        label={<div dangerouslySetInnerHTML={{ __html: content }} />}
        error={required && !checked && showErrors && t("agreementRequired")}
      />
    );
  };

  if (!agreements || agreements.length === 0) {
    return null;
  }

  return (
    <>
      <Space h="xl" />
      <Stack>{agreements.map(mapAgreementUI)}</Stack>
      <Space h="xl" />
    </>
  );
};

export default Agreements;
